import React, { useState, useEffect } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

// Billing page components
import MenuItem from "pages/Dashboard/components/MenuItem";
import { Button, Divider } from "@mui/material";
import OrderDetails from "pages/Dashboard/components/OrderDetails";
import ClaimDetails from "pages/Dashboard/components/ClaimDetails";
import ProfileDetails from "pages/Dashboard/components/ProfileDetails";
import TransactionDetails from "pages/Dashboard/components/TransactionDetails";
import Receipt from "pages/Dashboard/components/Receipt";

function DashboardMenu() {
  const [currentDetails, setCurrentDetails] = useState("policies");

  const handleChangeDetails = (item) => {
    setCurrentDetails(item);
  };

  return (
    <Grid container spacing={3} p={3}>
      <Grid item xs={12} md={3} lg={3}>
        {/* <Card
          sx={{
            p: 2,
            mx: { xs: 2, lg: 3 },
            mt: -8,
            mb: 4,
            backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
              rgba(white.main, 0.8),
            backdropFilter: "saturate(200%) blur(30px)",
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        > */}
        <MKBox p={2}>
          <MKBox
            component="ul"
            display="flex"
            flexDirection="column"
            p={0}
            m={0}
          >
            <Button
              variant="text"
              sx={{ justifyContent: "stretch" }}
              size="small"
              onClick={() => handleChangeDetails("policies")}
            >
              <MenuItem variant="button" title="Policy Orders" icon="policy" />
            </Button>
            <Button
              variant="text"
              sx={{ justifyContent: "stretch" }}
              size="small"
              onClick={() => handleChangeDetails("transactions")}
            >
              <MenuItem
                variant="button"
                title="Transactions"
                icon="receipt_long"
              />
            </Button>
            <Button
              variant="text"
              sx={{ justifyContent: "stretch" }}
              size="small"
              onClick={() => handleChangeDetails("claims")}
            >
              <MenuItem title="Claims" icon="approval" />
            </Button>
            <Button
              variant="text"
              sx={{ justifyContent: "stretch" }}
              size="small"
              onClick={() => handleChangeDetails("profile")}
            >
              <MenuItem title="Profile" icon="person" />
            </Button>
            {/* <Button
                variant="text"
                sx={{ justifyContent: "stretch" }}
                size="small"
                onClick={() => handleChangeDetails("receipt")}
              >
                <MenuItem title="Receipt" icon="person" />
              </Button> */}
            {/* <Button
                variant="text"
                sx={{ justifyContent: "stretch" }}
                size="small"
                onClick={() => handleChangeDetails("settings")}
              >
                <MenuItem title="Settings" icon="settings" />
              </Button> */}
          </MKBox>
        </MKBox>
        {/* </Card> */}
      </Grid>
      <Grid item xs={12} md={9} lg={9}>
        {/* <Card
          sx={{
            p: 2,
            mx: { xs: 2, lg: 3 },
            mt: -8,
            mb: 4,
            backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
              rgba(white.main, 0.8),
            backdropFilter: "saturate(200%) blur(30px)",
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        > */}
        {currentDetails == "policies" ? (
          <>
            <MKBox pt={3} px={2}>
              <MKTypography variant="h6" fontWeight="medium" px={3}>
                Ordered Policies
              </MKTypography>
            </MKBox>
            <Divider />
            <MKBox pt={1} pb={2} px={2}>
              <OrderDetails />
            </MKBox>
          </>
        ) : currentDetails === "transactions" ? (
          <>
            <MKBox pt={3} px={2}>
              <MKTypography variant="h6" fontWeight="medium" px={3}>
                Transactions
              </MKTypography>
            </MKBox>
            <Divider />
            <MKBox pt={1} pb={2} px={2}>
              <TransactionDetails />
            </MKBox>
          </>
        ) : currentDetails === "claims" ? (
          <>
            <MKBox pt={3} px={2}>
              <MKTypography variant="h6" fontWeight="medium" px={3}>
                Claims
              </MKTypography>
            </MKBox>
            <Divider />
            <MKBox pt={1} pb={2} px={2}>
              <ClaimDetails />
            </MKBox>
          </>
        ) : currentDetails === "profile" ? (
          <>
            <MKBox pt={3} px={2}>
              <MKTypography variant="h6" fontWeight="medium" px={3}>
                Profile
              </MKTypography>
            </MKBox>
            <Divider />
            <MKBox pt={1} pb={2} px={2}>
              <ProfileDetails />
            </MKBox>
          </>
        ) : // ) : currentDetails === "receipt" ? (
        //   <>
        //     <MKBox pt={3} px={2}>
        //       <MKTypography variant="h6" fontWeight="medium" px={3}>
        //         Receipt
        //       </MKTypography>
        //     </MKBox>
        //     <Divider />
        //     <MKBox pt={1} pb={2} px={2}>
        //       <Receipt />
        //     </MKBox>
        //   </>
        currentDetails === "settings" ? (
          <>
            <MKBox pt={3} px={2}>
              <MKTypography variant="h6" fontWeight="medium" px={3}>
                Settings
              </MKTypography>
            </MKBox>
            <Divider />
            <MKBox pt={1} pb={2} px={2}>
              {/* <DashboardDetails /> */}
            </MKBox>
          </>
        ) : (
          <></>
        )}
        {/* </Card> */}
      </Grid>
    </Grid>
  );
}

export default DashboardMenu;
